import { createTheme } from '@material-ui/core/styles';
import lightTheme from 'config/themes/lightTheme';

const retailTheme = createTheme({
  ...lightTheme,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});
export default retailTheme;
